<template>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="pro_tabs_box">
        <el-tab-pane v-if="checkPermission(['radarManage_tab_databoard'],permissionLists)" :disabled="!isover" label="数据看板" name="数据看板"></el-tab-pane>
        <el-tab-pane v-if="checkPermission(['radarManage_tab_clue'],permissionLists)" :disabled="!isover" label="流程数据" name="流程数据"></el-tab-pane>
        <el-tab-pane v-if="checkPermission(['radarManage_tab_company'],permissionLists)" :disabled="!isover" label="企业库" name="企业库"></el-tab-pane>
        <el-tab-pane v-if="checkPermission(['radarManage_tab_collect'],permissionLists)" :disabled="!isover" label="区域配置" name="区域配置"></el-tab-pane>
        <el-tab-pane v-if="checkPermission(['radarManage_tab_task'],permissionLists)" :disabled="!isover" label="采集任务" name="采集任务"></el-tab-pane>
    </el-tabs>
</template>
<script>
import xz from "@/common";
import checkPermission from '@/utils/permission' // 权限判断函数
export default{
    data() {
        return{
            activeName:'',
            isover:true,
            // 按钮权限参数
            butQuery:{
                path:'/radarManage',
                powerEnName:'product'
            },
            permissionLists:[]
        }
    },
    created(){
        this.getButtonPower()
        // console.log('yy',this.listQuerys)
        if(!this.isNull(this.$route.query.active)){
            this.activeName = this.$route.query.active
        }
        // 向父组件传值
        this.$emit('change', this.activeName);
    },
    // watch: {
    // '$store.state.resourceComTabsIsover': function () {
    //   this.isover = this.$store.state.resourceComTabsIsover
    // //   console.log('d',this.isover)
    // }
//   },
    methods:{
        checkPermission,
        // 获取按钮权限
        getButtonPower(){
            xz.getbtnPowerIdBypage(this.butQuery).then(res => {
                // console.log('按钮',res)
                if(res.status == 'ok'){
                    let resmsg = res.msg
                    if(!this.isNull(resmsg)){
                        for (let index = 0; index < resmsg.length; index++) {
                            let element = resmsg[index];
                            this.permissionLists.push(element.Enname);
                        }
                        if((this.checkPermission(['radarManage_tab_databoard'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
                            this.activeName = '数据看板'
                            this.$router.push({
                                path: '/radarManage',
                                query:{
                                    active:'数据看板'
                                }
                            })
                        }else if((!this.checkPermission(['radarManage_tab_databoard'],this.permissionLists))&&(this.checkPermission(['radarManage_tab_clue'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
                            this.activeName = '流程数据'
                            this.$router.push({
                                path: '/processData',
                                query:{
                                    active:'流程数据'
                                }
                            })
                        }else if((!this.checkPermission(['radarManage_tab_databoard'],this.permissionLists))&&(!this.checkPermission(['radarManage_tab_clue'],this.permissionLists))&&(this.checkPermission(['radarManage_tab_company'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
                            this.activeName = '企业库'
                            this.$router.push({
                                path: '/enterpriseLibrary',
                                query:{
                                    active:'企业库'
                                }
                            })
                        }else if((this.checkPermission(['radarManage_tab_collect'],this.permissionLists))&&(!this.checkPermission(['radarManage_tab_databoard'],this.permissionLists))&&(!this.checkPermission(['radarManage_tab_clue'],this.permissionLists))&&(!this.checkPermission(['radarManage_tab_company'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
                            this.activeName = '区域配置'
                            this.$router.push({
                                path: '/collectSet',
                                query:{
                                    active:'区域配置'
                                }
                            })
                        }else if((!this.checkPermission(['radarManage_tab_collect'],this.permissionLists))&&(!this.checkPermission(['radarManage_tab_databoard'],this.permissionLists))&&(!this.checkPermission(['radarManage_tab_clue'],this.permissionLists))&&(!this.checkPermission(['radarManage_tab_company'],this.permissionLists))&&(this.checkPermission(['radarManage_tab_task'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
                            this.activeName = '采集任务'
                            this.$router.push({
                                path: '/taskList',
                                query:{
                                    active:'采集任务'
                                }
                            })
                        }
                    }else{
                        this.permissionLists = []
                        this.activeName = ''
                    }
                }else{
                    this.permissionLists = []
                    this.activeName = ''
                }
            })
        },
        handleClick(tab) {
            // 向父组件传递了两个值
            this.$emit('change', tab.name);
            if(tab.name == '数据看板'){
                this.$router.push({
                    path: '/radarManage',
                    query:{
                        active:'数据看板'
                    }
                })
            }
            if(tab.name == '区域配置'){
                this.$router.push({
                    path: '/collectSet',
                    query:{
                        active:'区域配置'
                    }
                })
            }
            if(tab.name == '采集任务'){
                this.$router.push({
                    path: '/taskList',
                    query:{
                        active:'采集任务'
                    }
                })
            }
            if(tab.name == '企业库'){
                this.$router.push({
                    path: '/enterpriseLibrary',
                    query:{
                        active:'企业库'
                    }
                })
            }
            if(tab.name == '流程数据'){
                this.$router.push({
                    path: '/processData',
                    query:{
                        active:'流程数据'
                    }
                })
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
        }
    }
}
</script>
<style>
.pro_tabs_box.el-tabs{
    background: #fff;
}
</style>